<template>
  <div id="insights-text-summary" class="card px-4 py-3 mb-3 h-100">
    <div v-if="!hasSummary && summariesUnavailable" data-testid="ai-summary-unavailable">
      - Summary temporarily unavailable. Please try again later.
    </div>
    <div v-else-if="!hasSummary" data-testid="ai-summary-empty">
      - No summary for selected filters
    </div>

    <div v-else>
      <div v-if="positiveSummary">
        <div class="mb-1" style="font-size: 13px">Summary of Positive Reviews</div>
        <p data-testid="ai-summary-positive">{{ positiveSummary }}</p>
      </div>

      <div v-if="negativeSummary">
        <div class="mb-1" style="font-size: 13px">Summary of Negative Reviews</div>
        <p data-testid="ai-summary-negative">{{ negativeSummary }}</p>
      </div>

      <div
        v-if="summariesUnavailable"
        class="text-muted small mb-2"
        data-testid="ai-summary-partial"
      >
        - Part of this summary is temporarily unavailable. Please try again later.
      </div>

      <div class="text-right">
        <button class="btn btn-primary btn-sm" @click="showDetails" v-if="showButton">
          See Reviews
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsightsTextSummary',
  props: {
    positiveSummary: {
      type: String
    },
    negativeSummary: {
      type: String
    },
    showButton: {
      type: Boolean,
      default: false
    },
    summariesUnavailable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasSummary() {
      return Boolean(this.positiveSummary || this.negativeSummary)
    }
  },
  methods: {
    showDetails() {
      this.$router.push({
        path: '/insights/v2/details',
        query: { ...this.$route.query }
      })
    }
  }
}
</script>
